import * as App from '../../app';
export function showNativeAfterTimer(game) {
    var _a = App.settings.get(), nativeEffectType = _a.nativeEffectType, nativeEffectTime = _a.nativeEffectTime, nativeEffectSpeed = _a.nativeEffectSpeed;
    var time = nativeEffectTime / (nativeEffectSpeed / 100);
    if (nativeEffectType > 0) {
        setTimeout(function () { return game.adTimerEffect(nativeEffectType); }, 200);
        setTimeout(function () { return App.Fn.showNative(); }, time);
    }
    else {
        App.Fn.showNative();
    }
}
